export default __webpack_public_path__ + "static/media/W-logo.fe37fff5.svg";